import { render, staticRenderFns } from "./WebsiteFooter.vue?vue&type=template&id=5e70f170&scoped=true"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js"
import style0 from "./WebsiteFooter.vue?vue&type=style&index=0&id=5e70f170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70f170",
  null
  
)

export default component.exports